import type { FieldErrors } from '../types/form'

export function clearAllResolvedErrors({
  currentErrors,
  newErrors,
}: {
  currentErrors?: FieldErrors
  newErrors: FieldErrors
}): FieldErrors {
  if (currentErrors) {
    return Object.keys(currentErrors).reduce((acc, key) => {
      if (newErrors[key]) {
        return {
          ...acc,
          [key]: newErrors[key],
        }
      }
      return acc
    }, {})
  }

  return {}
}
